import { render, staticRenderFns } from "./manage-warehouse.vue?vue&type=template&id=509c1005&scoped=true"
import script from "./manage-warehouse.vue?vue&type=script&lang=js"
export * from "./manage-warehouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509c1005",
  null
  
)

export default component.exports